var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Callback =
/*#__PURE__*/
function () {
  "use strict";

  function Callback(transaction) {
    _classCallCheck(this, Callback);

    this.transaction = transaction;
    this.map = {};
    this.status = "";
    this.hash = "";
  }

  _createClass(Callback, [{
    key: "on",
    value: function on(msg, f) {
      this.map[msg] = f;
      if (msg === "success") this._start();
      return this;
    }
  }, {
    key: "pushMsg",
    value: function pushMsg(msg, args) {
      var f = this.map[msg];

      if (f === undefined) {
        return;
      }

      f(args);
    }
  }, {
    key: "_start",
    value: function _start() {
      this.status = "pending";
      var i = 1;
      var self = this;
      var id = setInterval(function () {
        if (self.status === "success" || self.status === "failed" || i > 90) {
          clearInterval(id);

          if (self.status !== "success" && self.status !== "failed" && i > 90) {
            self.pushMsg("failed", "Error: tx " + self.hash + " on chain timeout.");
          }

          return;
        }

        i++;
        self.transaction.getTxReceiptByTxHash(self.hash).then(function (res) {
          if (res.status_code === "SUCCESS" && self.status === "pending") {
            self.pushMsg("success", res);
            self.status = "success";
          } else if (res.status_code !== undefined && self.status === "pending") {
            self.pushMsg("failed", res);
            self.status = "failed";
          }
        }).catch(function (e) {// console.log(i)
        });
      }, 1000);
    }
  }]);

  return Callback;
}();

module.exports = Callback;